(() => {
  if (window.zippoContactExperience) return;
  window.zippoContactExperience = true;
  const initialized = new WeakSet();
  function attach(root = document) {
    root.querySelectorAll('[data-zc-contact]').forEach(contact => {
      if (initialized.has(contact)) return;
      initialized.add(contact);
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const pressed = new Map();
      const showPress = event => {
        if (motion.matches) return;
        const control = event.target.closest?.('.zc-button, .zc-channels>a, .zc-photo-caption, .zc-map__activate, .zq-submit');
        if (!control || !contact.contains(control) || control.matches(':disabled, [aria-disabled="true"]')) return;
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
        const box = control.getBoundingClientRect();
        const pointer = event.type === 'pointerdown';
        control.style.setProperty('--zc-press-x', (pointer ? event.clientX - box.left : box.width / 2) + 'px');
        control.style.setProperty('--zc-press-y', (pointer ? event.clientY - box.top : box.height / 2) + 'px');
        clearTimeout(pressed.get(control));
        control.classList.add('zc-pressed');
        pressed.set(control, setTimeout(() => {
          control.classList.remove('zc-pressed');
          control.style.removeProperty('--zc-press-x');
          control.style.removeProperty('--zc-press-y');
          pressed.delete(control);
        }, 450));
      };
      contact.addEventListener('pointerdown', showPress);
      contact.addEventListener('keydown', showPress);
      contact.querySelector('[data-zc-map]')?.addEventListener('click', event => {
        const button = event.currentTarget;
        const frame = document.createElement('iframe');
        frame.title = button.dataset.zcMapTitle;
        frame.src = 'https://maps.google.com/maps?q=ZIPPOPIU.it%2C%20Via%20Ruca%2056%2C%20Lumezzane&output=embed';
        frame.referrerPolicy = 'no-referrer-when-downgrade';
        frame.allowFullscreen = true;
        button.closest('[data-zc-map-viewport]').replaceChildren(frame);
        frame.focus();
      });
    });
  }
  attach();
  document.addEventListener('shopify:section:load', event => attach(event.target));
})();
